import { useCallback, useMemo, useState } from 'react';

import { addDays, differenceInDays, format, parse, parseISO } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { useHistory } from 'react-router-dom';

import { formatProfileCode } from '~/utils/formatProfileCode';
import { cpfFormatter } from '~/utils/formatter';

import { TrainingProgram } from '../types';

import * as S from './styles';

type Props = {
  data: TrainingProgram;
};

function calculateDeadLine(data1: any, data2: any): number {
  const difference = differenceInDays(data1, new Date(data2));

  if (difference < 0) {
    return difference;
  }
  if (difference === 0) {
    return difference;
  }

  return difference + 1;
}

export function Card({ data }: Props) {
  const { push } = useHistory();

  const trainingStatusVariations: { [key: string]: string } = {
    pending: 'Pendente',
    emited: 'Emitido',
    canceled: 'Cancelado',
    expired: 'Expirado',
  };

  const [deadlineIsExpired, setDeadlineIsExpired] = useState<boolean>(false);

  const deadline = useMemo(() => {
    const date = new Date();

    let difference;

    if (data?.status === 'pending' || data?.status === 'expired') {
      difference = calculateDeadLine(
        addDays(parseISO(data?.delivery_date?.toString()), 0),
        addDays(parseISO(date.toISOString()), 0),
      );
    }
    if (data?.programs?.number_of_program === 1) {
      difference = calculateDeadLine(
        parseISO(data?.delivery_date?.toString()),
        parseISO(data?.emition_date?.toString()),
      );
    }
    if (data?.delivery_date) {
      difference = calculateDeadLine(
        addDays(parseISO(data?.delivery_date?.toString()), 1),
        addDays(parseISO(data?.emition_date?.toString()), 1),
      );
    }

    difference && difference < 0 && setDeadlineIsExpired(true);

    return Number.isNaN(difference) ? '--' : `${difference} dias`;
  }, [data]);

  const handleNavigateToTraining = useCallback(() => {
    push(`students/${data?.student.id}`, { component: 'trainingPrograms' });
  }, [push, data]);

  return (
    <S.Container onClick={handleNavigateToTraining} expired={deadlineIsExpired}>
      <div>
        <strong>Nome: </strong> {data?.student.user.name}
      </div>

      <div>
        <strong>CPF: </strong> {cpfFormatter(data?.student.cpf)}
      </div>

      <div>
        <strong>Status do cadastro: </strong>
        {data?.student?.status === 'active' ? 'Ativo' : 'Inativo'}
      </div>

      <div>
        <strong>Fatura: </strong> {data?.billing.id}
      </div>

      <div>
        <strong>Programa de treino: </strong> {data?.program_id}
      </div>

      <div>
        <strong>Treino: </strong>
        {`${data?.programs.number_of_program}/${data?.billing.package.number_of_training_programs}`}
      </div>

      <div>
        <strong>Modelo de ficha: </strong> {data?.data_model}
      </div>

      <div>
        <strong>Divisões de treino: </strong>
        {data?.divisions.map((division: any) => division.division).join(', ')}
      </div>

      <div>
        <strong>Entrega programada: </strong>
        {format(
          new Date(data?.programs?.trainingManangement?.delivery_date),
          'dd/MM/yyyy',
        ) ?? 'Não selecionado'}
      </div>

      <div>
        <strong>Data de emissão: </strong>
        {format(
          new Date(
            `${data?.programs?.trainingManangement?.emition_date}T00:00:00`,
          ),
          'dd/MM/yyyy',
        ) ?? 'Não selecionado'}
      </div>

      <div>
        <strong>Status do treino: </strong>
        {trainingStatusVariations[
          data?.programs?.trainingManangement?.status
        ] ?? 'Pendente'}
      </div>

      <div>
        <strong>Deadline: </strong>
        <strong>
          <span>{deadline}</span>
        </strong>
      </div>

      <div>
        <strong>ProfileCode:</strong>
        <br />
        {formatProfileCode(data?.datasheet?.profile_code)}
      </div>
    </S.Container>
  );
}
